import { FrontendApplication, FrontendApplicationContribution, WidgetManager } from '@theia/core/lib/browser';
import { Widget } from '@theia/core/lib/browser/widgets/widget';
import { inject, injectable } from '@theia/core/shared/inversify';
import { EditorUiHostWidget } from './editor-ui-host-widget';

@injectable()
export class EditorUiHostContribution implements FrontendApplicationContribution {
    @inject(WidgetManager)
    protected readonly widgetManager!: WidgetManager;

    async onStart(_app: FrontendApplication): Promise<void> {
        const widget: EditorUiHostWidget = await this.widgetManager.getOrCreateWidget(EditorUiHostWidget.ID);
        if (!widget.isAttached) {
            Widget.attach(widget, document.body);
        }
    }
}
